import axios from "axios";

export const getDrumQualities = async () => {
    const response = await axios.get("api/drumqualities");
    const result = response.data;
    return result;
}